import React from "react"
import Thumbnail from "./thumbnail"
import Sound from "./sound"
import GalleryThumbnail from "./gallery-thumbnail"
import GallerySketchbook from "./gallery-sketchbook"
import Sketchbook from "./sketchbook"
import { injectIntl } from 'gatsby-plugin-intl'

const Figures = ({ figures, data, pre, size, intl: { locale } }) => {
  return (
    <div className="figures">
      {figures.map((image, index) => {
        let block = ""
        let ref

        if (image._typename === "thumbnail") {
          const caption = { reference: image.reference, ...image[`caption_${locale}`] }

          ref = image.reference
          block = (
            <Thumbnail
              fluid={image.image ? data[image.image].childImageSharp.fluid : false}
              original={image.image ? data[image.image].childImageSharp.original : false}
              caption={caption}
              size={size}
            />
          )
        }

        if (image._typename === "sketchbook") {
          const caption = { reference: image.reference, ...image[`caption_${locale}`] }
          const fluids = data[image.images].edges.map(
            ({ node }) => node.childImageSharp.fluid
          )
          const originals = data[image.images].edges.map(
            ({ node }) => node.childImageSharp.original
          )

          ref = image.reference
          block = (
            <Sketchbook
              fluids={fluids}
              caption={caption}
              originals={originals}
              size={size}
            />
          )
        }

        if (image._typename === "sound") {
          const caption = { reference: image.reference, ...image[`caption_${locale}`] }
          const src = data[image.sound].publicURL
          // const src = "http://www.nihilus.net/soundtracks/Static%20Memories.mp3"

          ref = image.reference
          block = <Sound caption={caption} src={src} />
        }

        if (image._typename === "gallery") {
          const captions = image.reference.map((r, j) => {
            const caption = image[`caption_${locale}`][j]
            caption.reference = r
            return caption
          })
          const fluids = image.image.map(j => data[j].childImageSharp.fluid)
          const originals = image.image.map(
            j => data[j].childImageSharp.original
          )

          ref = `${image.reference[0]}-${
            image.reference[image.reference.length - 1]
            }`
          block = (
            <GalleryThumbnail
              fluids={fluids}
              captions={captions}
              originals={originals}
              size={size}
            />
          )
        }

        if (image._typename === "gallery-sketchbook") {
          const captions = image.reference.map((r, j) => {
            const caption = image[`caption_${locale}`][j]
            caption.reference = r
            return caption
          })
          const fluids = image.images.map(j => data[j].edges.map(
            ({ node }) => node.childImageSharp.fluid
          ))
          const originals = image.images.map(j => data[j].edges.map(
            ({ node }) => node.childImageSharp.original
          ))

          ref = `${image.reference[0]}`
          block = (
            <GallerySketchbook
              fluids={fluids}
              captions={captions}
              originals={originals}
              size={size}
            />
          )
        }

        return (
          <div
            key={index}
            id={`fig-${pre}-${ref}`}
            className={`figures__block figures__block--size-${image.size}`}
          >
            {block}
          </div>
        )
      })}
    </div>
  )
}

export default injectIntl(Figures)
